
import { decode as decodeToken } from 'jsonwebtoken'
const axios = require('@/lib/axios').default

export function loginByToken(idToken, kid = null){
  if(!kid){
    kid = decodeToken(idToken, { complete: true }).header.kid
  }
  return axios.post('/wordprison/auth/google', {
    idToken,
    kid
  })
}
